import LocalizedStrings from 'react-localization'
import it from '@helpercontents/Localization/it'
import en from '@helpercontents/Localization/en'

const HelperLocalization = new LocalizedStrings({
    it,
    en
})

export default HelperLocalization